function normalize(text) {
  if (text === null || text === undefined || text === '') {
    return null;
  }
  const value = String(text).trim();
  return value === '' ? null : value;
}

const COUNTRY_ALIASES = {
  ca: 'Canada',
  canada: 'Canada',
  us: 'United States',
  usa: 'United States',
  'united states': 'United States',
};

export function canonicalizeCountry(text) {
  const normalized = normalize(text);
  if (normalized === null) {
    return null;
  }
  return COUNTRY_ALIASES[normalized.toLowerCase()] || normalized;
}

function dedupeAndSort(values) {
  const seen = new Set();
  const result = [];
  for (const value of values) {
    const normalized = canonicalizeCountry(value);
    if (normalized === null || seen.has(normalized)) {
      continue;
    }
    seen.add(normalized);
    result.push(normalized);
  }
  return result.sort((left, right) => left.localeCompare(right));
}

function matches(record, universe, country, sector) {
  return (
    record.universe === universe &&
    (country === null || canonicalizeCountry(record.country) === canonicalizeCountry(country)) &&
    (sector === null || record.sector === sector)
  );
}

export function createHierarchy(records) {
  const normalizedRecords = Array.isArray(records) ? records : [];
  const api = {
    getCountries: (universe) =>
      dedupeAndSort(
        normalizedRecords
          .filter((record) => record.universe === universe)
          .map((record) => canonicalizeCountry(record.country))
      ),
    getSectors: (universe, country = null) =>
      dedupeAndSort(
        normalizedRecords
          .filter((record) => matches(record, universe, country, null))
          .map((record) => record.sector)
      ),
    getIndustries: (universe, country = null, sector = null) =>
      dedupeAndSort(
        normalizedRecords
          .filter((record) => matches(record, universe, country, sector))
          .map((record) => record.industry)
      ),
    isValidCombination: (universe, country = null, sector = null, industry = null) =>
      normalizedRecords.some(
        (record) =>
          matches(record, universe, country, sector) &&
          (industry === null || record.industry === industry)
      ),
    clearDependentFilters: ({ universe, country, sector, industry }) => {
      const next = {
        universe: normalize(universe),
        country: canonicalizeCountry(country),
        sector: normalize(sector),
        industry: normalize(industry),
      };

      if (!next.universe) {
        next.country = null;
        next.sector = null;
        next.industry = null;
        return next;
      }

      if (!api.isValidCombination(next.universe, next.country, null, null)) {
        next.country = null;
        next.sector = null;
        next.industry = null;
        return next;
      }

      if (!api.isValidCombination(next.universe, next.country, next.sector, null)) {
        next.sector = null;
        next.industry = null;
        return next;
      }

      if (!api.isValidCombination(next.universe, next.country, next.sector, next.industry)) {
        next.industry = null;
      }

      return next;
    },
  };
  return api;
}

export default { createHierarchy };
